import "core-js";
import "regenerator-runtime/runtime";
import React from 'react';
import { renderReact } from '../src/lib/ssrHydrator';
import ArticleSearchContainer from '../src/ArticleSearchForm/containers/ArticleSearchContainer'
import FormItemsConteiner from '../src/ArticleSearchForm/containers/FormItemsContainer';
import { PCArticleListWrapper } from './PCArticleList';
import Form from '../src/ArticleSearchForm/components/shared/pc/Form';
import PagingZone from '../src/ArticleSearchForm/components/shared/pc/PagingZone';
import Loader from '../src/ArticleSearchForm/components/shared/common/Loader';
import ErrorBoundary from '../src/ErrorBoundary/error_notifier'

const PCArticleSearchForm = (props) => {
  return (
    <ErrorBoundary>
      <ArticleSearchContainer.Provider initialState={{...props, requestFromSp: false}}>
        <FormItemsConteiner.Provider initialState={{items: props.items}}>
          <>
            <PagingZone>
              <PCArticleListWrapper />
            </PagingZone>
            <Form />
            <Loader/>
          </>
        </FormItemsConteiner.Provider>
      </ArticleSearchContainer.Provider>
    </ErrorBoundary>
  );
};

export default renderReact('PCArticleSearchForm', PCArticleSearchForm);
